<template>
  <v-card
    class="wrapper rounded-xl fill-height grey lighten-3"
    :class="{ 'mobile-left-margin' : this.$vuetify.breakpoint.smAndDown }"
    flat
  >
    <v-card-title class="pb-0">
      <v-row class="flex-nowrap">
        <v-col class="flex-grow-1 pr-2">
          {{ project.titulo }}
        </v-col>
        <v-col class="flex-grow-0 pl-2">
          <v-btn
            @click="$emit('close')"
            icon
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-card-title>

    <v-card-subtitle class="pt-3 pb-0">
      <span
        v-for="field in subtitleFields"
        :key="field.key"
        class="mr-1"
      >
        <span v-if="project[field.key]">
          <span class="font-weight-bold">{{ $t(field.title) }}: </span>
          <span>{{ project[field.key] }}.</span>
        </span>
      </span>
    </v-card-subtitle>
    
    <v-card-subtitle class="pt-2">
      {{ project.instrucoes_gerais }}
    </v-card-subtitle>

    <v-card-text>
      <v-row>
        <v-col
          v-for="(item, index) in project.itens_solicitados"
          :key="index"
          class="pa-2 card-content"
          cols="12"
          sm="6"
          xl="3"
        >
          <v-card
            class="rate-card-wrapper rounded-lg d-flex flex-column"
            outlined
          >
            <v-card-title class="text-subtitle-2 pb-0">
              <v-row>
                <v-col class="flex-grow-1 pr-1">
                  {{ item.produto }}
                </v-col>
                <v-col class="flex-grow-0 text-no-wrap pl-1">
                  {{ `#${index + 1}` }}
                </v-col>
              </v-row>
            </v-card-title>

            <v-card-text class="rate-card-content pa-0 d-flex flex-column flex-grow-1">
              <v-list dense>
                <v-list-item v-for="(field, index) in cardFields" :key="index" class="rate-card-item py-0">
                  <v-list-item-title
                    class="card-field py-1"
                    v-if="(!Array.isArray(item[field.key]) && item[field.key]) || (Array.isArray(item[field.key]) && item[field.key].length)"
                  >
                    <span
                      class="font-weight-bold"
                      :class="{
                        'red--text': field.key == 'atencao',
                      }"
                    >{{ $t(field.title) }}: </span>

                    <span class="font-weight-regular">
                      <span v-if="Array.isArray(item[field.key])">
                        {{ item[field.key].join(', ') }}
                      </span>
                      <span v-else>{{ item[field.key] }} </span>
                    </span>
                  </v-list-item-title>
                </v-list-item>
              </v-list>

              <v-spacer></v-spacer>

              <div
                v-if="item.links.length > 0"
                class="px-3 mb-2"
              >
                <v-chip
                  v-for="(link, index) in item.links"
                  :key="index + link"
                  class="ma-1 flex-grow-0 flex-shrink-0"
                  color="blue lighten-3"
                  small
                >
                  <a
                    :href="link"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="text-decoration-none white--text"
                  >
                    Link {{ index + 1 }}
                  </a>
                </v-chip>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-card-text>

    <v-card-actions class="floating-actions">
      <v-hover v-slot="{ hover }">
        <v-btn
          @click="$emit('create-job', project)"
          color="primary"
          rounded
        >
          <v-icon
            :left="hover"
          >mdi-arrow-top-right-bold-outline</v-icon>
          <v-slide-x-transition leave-absolute hide-on-leave>
            <span v-if="hover" class="transition-fast-in-fast-out pr-3">{{ $t('create_job') }}</span>
          </v-slide-x-transition>
        </v-btn>
      </v-hover>
    </v-card-actions>
  </v-card>
</template>

<style scoped>
  .wrapper {
    overflow-y: auto;
  }

  .rate-card-wrapper {
    border-color: darkgrey;
    height: 100%;
  }

  .rate-card-content {
    overflow-y: auto;
    max-height: 250px;
  }

  .rate-card-item {
    min-height: fit-content !important;
    padding-top: 4px;
    padding-bottom: 4px;
  }

  .card-content {
    max-width: 400px;
  }

  .card-field {
    overflow-wrap: break-word;
    white-space: break-spaces;
    line-break: anywhere;
  }

  .floating-actions {
    position: fixed;
    bottom: 20px;
    right: 25px;
    z-index: 1000;
  }

  .mobile-left-margin {
    margin-left: calc(56px);
  }
</style>

<script>
  export default {
    name: 'ChatProjectDetailView',

    props: {
      project: {
        type: Object,
        default: () => {}
      }
    },

    data() {
      return {
        subtitleFields: [
          {
            title: 'delivery_date',
            key: 'data_entrega',
          },
          {
            title: 'agency',
            key: 'agency',
          },
          {
            title: 'customer',
            key: 'customer',
          },
        ],
        cardFields: [
          {
            title: 'produto',
            key: 'ratecard_id',
          },
          {
            title: 'escopo_detectado',
            key: 'escopo_detectado',
          },
          {
            title: 'tipo_cobranca',
            key: 'tipo_cobranca',
          },
          {
            title: 'quantidade',
            key: 'quantidade',
          },
          {
            title: 'formatos',
            key: 'formatos',
          },
          {
            title: 'observacao',
            key: 'observacao',
          },
          {
            title: 'atencao',
            key: 'atencao',
          },
        ],
      }
    },
  }
</script>
